module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d1893578e9f1038e5b70b19465f7b58b.png";